import type { FC } from 'react';

import { IconTooltip } from 'Components/shared/IconTooltip';
import { T } from 'Features/SellerCommunications/utils/translate';
import { triggerSellerMessagingSubjectTooltipHoveredEvent } from 'Services/analytics/events';

import styles from './EmailForm.module.scss';

export const EmailSubjectSection: FC = () => {
	return (
		<section className={styles.emailSubject}>
			<label className={styles.label} htmlFor="emailSubject">
				{T.translate('createEmail.emailSubject.label')}
			</label>
			<span className={styles.subject}>{T.translate('createEmail.emailSubject.dynamicPlaceholder')}</span>
			<div className={styles.iconWrapper}>
				<IconTooltip
					content={T.translate('createEmail.emailSubject.tooltip')}
					iconProps={{ filled: true, id: 'emailSubjectTooltip', size: 'xsmall' }}
					maxWidth={'224px'}
					onMouseEnter={triggerSellerMessagingSubjectTooltipHoveredEvent}
					side="top"
				/>
			</div>
		</section>
	);
};
